module.exports = __webpack_public_path__ + "static/media/uisce-eireann.8e2ca5f5.jpg";